<!-- 论文初稿 -->
<template>
  <svg
    t="1748247077419"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="42533"
    width="200"
    height="200"
  >
    <path
      d="M725.333 960H128c-23.467 0-42.667-19.2-42.667-42.667v-640c0-23.466 19.2-42.666 42.667-42.666h128v-128C256 83.2 275.2 64 298.667 64H896c23.467 0 42.667 19.2 42.667 42.667v640c0 23.466-19.2 42.666-42.667 42.666H768v128C768 940.8 748.8 960 725.333 960z m-554.666-85.333h512V320h-512v554.667z m170.666-725.334v85.334h384c23.467 0 42.667 19.2 42.667 42.666V704h85.333V149.333h-512z"
      fill="#216BEF"
      p-id="42534"
    />
    <path
      d="M298.667 490.667h128c23.466 0 42.666-19.2 42.666-42.667s-19.2-42.667-42.666-42.667h-128C275.2 405.333 256 424.533 256 448s19.2 42.667 42.667 42.667M512 576H298.667C275.2 576 256 595.2 256 618.667s19.2 42.666 42.667 42.666H512c23.467 0 42.667-19.2 42.667-42.666S535.467 576 512 576"
      fill="#216BEF"
      p-id="42535"
    />
  </svg>
</template>
